import {Component, EventEmitter, Injector, Input, Output, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {InspectionApiService} from '@api/inspection.api.service';
import {Conclusion} from '@namespaces/conclusion.namespace';
import InspectionWithForm = Conclusion.InspectionWithForm;
import Defect = Conclusion.Defect;
import DefectStatusesSelectValues = Conclusion.DefectStatusesSelectValues;
import {
    DynamicFieldsGroupComponent
} from '@subforms/dynamic-fields/components/dynamic-fields-group/dynamic-fields-group.component';
import {FormHelperService} from '@services/form-helper.service';
import {RadioValueInterface} from '@components/form-field/form-radio-buttons/form-radio-buttons.component';
import DefectStatus = Conclusion.DefectStatus;
import {DefectApiService} from '@api/defect.api.service';
import {FormArray} from '@angular/forms';
import {EventsService} from '@services/events.service';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';

@Component({
    selector: 'app-conclusion-defect-form',
    templateUrl: './conclusion-defect-form.component.html',
})
export class ConclusionDefectFormComponent extends FrontendFormComponent {

    @Input() inspection: InspectionWithForm;
    @Input() defect: Defect;

    @Output() canceled = new EventEmitter();

    @ViewChild(DynamicFieldsGroupComponent) params: DynamicFieldsGroupComponent;

    public statuses: RadioValueInterface[] = DefectStatusesSelectValues;

    public buttonName: string;

    form = this._fb.group({
        id: [],
        name: [],
        status: [DefectStatus.valid],
        params: this._fb.array([])
    });

    constructor(
        injector: Injector,
        public formService: InspectionApiService,
        private defectApi: DefectApiService,
        private events: EventsService,
        private conclusionFormService: ConclusionFormDataService,
    ) {
        super(injector);
    }

    get saveUrl() {
        return this.formService.getDefectPath(this.inspection.id);
    }

    get showParams(): boolean {
        return Number(this.form.get('status').value) === DefectStatus.invalid;
    }

    init() {
        this.buttonName = this.defect ? 'Сохранить' : 'Добавить';

        /**
         * В этот момент в компоненте динамических параметров еще не произошел хук ngOnInit,
         * поэтому передавать параметры формы будем напрямую, а не через @Input, чтобы параметры инициализировались для нужной формы
         */
        this.params.fbArray = this.form.get('params') as FormArray;

        if (this.defect) {
            FormHelperService.setFormValues(this.defect, this.form);
            this.params.restoreFields(this.inspection.defectParams);
        } else {
            this.params.setGroupStructure(this.inspection.defectParams);
        }
    }

    afterSave(defect: Defect) {
        this.isPending = false;
        this.updateDefectsInInspection(defect);
        this.canceled.emit();
    }

    removeDefect() {
        if (!this.defect) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить дефект?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.defectApi.delete({
                id: this.defect.id
            }).subscribe(() => {
                this.updateDefectsInInspection(this.defect, true);
            }, () => {

            });
        }, () => {});
    }

    /**
     * Обновить дефект в исптытании.
     *
     * Удалить, если он был удален
     * Добавить, если его не было
     * Заменить, если он уже был
     * @param defect
     * @param removed
     */
    private updateDefectsInInspection(defect: Defect, removed = false) {
        if (removed) {
            this.inspection.defects = this.inspection.defects.filter(def => def.id !== defect.id);
        } else {
            const index = this.inspection.defects.findIndex(def => def.id === defect.id);

            if (index >= 0) {
                this.inspection.defects = this.inspection.defects.map(def => def.id === defect.id ? defect : def);
            } else {
                this.inspection.defects.push(defect);
            }
        }

        this.conclusionFormService.updateStatuses();
    }
}
